/**
 * iurop-marquee.js — velocidad de marquesina normalizada en px/seg (Glucody).
 * El Liquid expone --marquee-pxps (ajuste "speed" del schema); aquí se mide UNA
 * copia de la lista y se fija --marquee-speed = ancho/pxps, de modo que todas
 * las marquesinas corren a la misma velocidad visual tengan los logos que
 * tengan (QA 15-jul: antes la duración era fija por vuelta y la velocidad real
 * dependía del nº/ancho de logos). Un ResizeObserver re-ajusta cuando terminan
 * de cargar las imágenes (el ancho de la lista cambia); al cambiar la duración
 * se conserva la FASE con animation-delay negativo para que no haya salto.
 * Sin JS: fallback CSS de 30s por vuelta.
 */
(function () {
  'use strict';

  if (window.__iuropMarqueeInit) return;
  window.__iuropMarqueeInit = true;

  function apply(m) {
    var list = m.querySelector('.glucody-marquee__list');
    var track = m.querySelector('.glucody-marquee__track');
    if (!list || !track) return;
    var pxps = parseFloat(getComputedStyle(m).getPropertyValue('--marquee-pxps')) || 0;
    var w = list.getBoundingClientRect().width;
    if (!pxps || !w) return;
    var dur = Math.max(5, w / pxps);
    var cur = parseFloat(m.style.getPropertyValue('--marquee-speed')) || 0;
    if (cur && Math.abs(dur - cur) / dur < 0.05) return; // sin cambios relevantes

    // Conservar la fase actual: leer el desplazamiento y convertirlo en delay
    // negativo con la nueva duración (un ciclo del keyframe = -25% del track).
    var frac = 0;
    try {
      var x = new DOMMatrixReadOnly(getComputedStyle(track).transform).m41;
      var quarter = track.getBoundingClientRect().width * 0.25;
      if (quarter > 0) frac = Math.min(Math.max(-x / quarter, 0), 1);
    } catch (e) { /* transform none */ }

    m.style.setProperty('--marquee-speed', dur.toFixed(2) + 's');
    track.style.animationDelay = (-frac * dur).toFixed(2) + 's';
  }

  function applyAll() {
    document.querySelectorAll('.glucody-marquee').forEach(apply);
  }

  function init() {
    document.querySelectorAll('.glucody-marquee').forEach(function (m) {
      apply(m);
      var list = m.querySelector('.glucody-marquee__list');
      if (list && 'ResizeObserver' in window) {
        new ResizeObserver(function () { apply(m); }).observe(list);
      }
    });
    // Cinturón del ResizeObserver: rotación / cambio de viewport
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(applyAll, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
